import DateFormat from "sap/ui/core/format/DateFormat";
import Type from "./Type";
import FormatException from "sap/ui/model/FormatException";
import UI5Date from "sap/ui/core/date/UI5Date";
import ParseException from "sap/ui/model/ParseException";
import ValidateException from "sap/ui/model/ValidateException";

export type MCDateTimeFormatOptions = {
    pattern?: string; // DateTime format pattern, e.g., "dd/MM/yyyy HH:mm:ss"
    strictParsing?: boolean; // Whether to enable strict parsing
}
export default class MCDateTime extends Type {
    private formatOptions: MCDateTimeFormatOptions;
    private dateTimeInstance;
    constructor(formatOptions?: MCDateTimeFormatOptions) {
        super();
        if (formatOptions) {
            this.formatOptions = {
                pattern: formatOptions.pattern || this.getPatternForLocale(), // Default date format
                strictParsing: formatOptions.strictParsing !== undefined ? formatOptions.strictParsing : true, // Enable strict parsing by default
            };
        }
        else {
            this.formatOptions = {
                pattern: this.getPatternForLocale(), // Default date format
                strictParsing: true, // Enable strict parsing by default
            };
        }
        this.dateTimeInstance = DateFormat.getDateTimeInstance(this.formatOptions);
    }

    private getPatternForLocale(): string {
        switch (this.locale) {
            case "en":
            case "fr":
            case "es":
                return "dd/MM/yyyy HH:mm:ss"; // Common European format
            case "de":
                return "dd.MM.yyyy HH:mm:ss"; // German format
            default:
                return "yyyy-MM-dd'T'HH:mm:ss"; // ISO format as default
        }
    }
    
    public formatValue(value: Date | string): string {
        if (!value) {
            return "";
        }
        if (typeof value === "string") {
            value = UI5Date.getInstance(value);
        }
        try {
            return this.dateTimeInstance.format(value);
        } catch {
            throw new FormatException(`Invalid date value: ${value instanceof Date ? value.toISOString() : value}`) as Error;
        }
    }
    
        public parseValue(value: string): Date {
            if (!value) {
                return null;
            }
            const date = this.dateTimeInstance.parse(value);
            if (!date || Array.isArray(date)) {
                throw new ParseException(`Invalid date format: ${value}`) as Error;
            }
            return date as Date;   
        }
        
        public validateValue(value: string): void {
            if (!value) {
                return;
            }
            const date = this.dateTimeInstance.parse(value);
            if (!date || Array.isArray(date)) {
                throw new ValidateException(`Invalid date format: ${value}`) as Error;
            }
        }
}